module.exports = __webpack_public_path__ + "img/DE.5c9661f6.svg";